import { useQuery } from "@tanstack/react-query"

import useUser from "@hooks/useUser"

import replaceSlugs from "@utils/replaceSlugs"

import { SUBTYPE_ENDPOINTS } from "@endpoints/pricebook"

import { SubtypeUsageByType } from "./PricebookTableView.types"

export const useSubtypeUsageQuery = () => {
    const { user } = useUser()

    const serviceCompanySlug = user?.service_company?.slug ?? "undefined"
    const usageEndpoint = replaceSlugs(SUBTYPE_ENDPOINTS.USAGE_BY_TYPE, {
        service_company_slug: serviceCompanySlug,
    })
    const subtypeUsageQueryKey = ["pricebook-subtypes-usage-by-type", usageEndpoint]

    return useQuery<SubtypeUsageByType>({
        queryKey: subtypeUsageQueryKey,
        queryFn: async (): Promise<SubtypeUsageByType> => {
            const response = await fetch(usageEndpoint)
            return (await response.json()) as SubtypeUsageByType
        },
        enabled: !!user?.service_company,
        staleTime: 600000, // Cache for 10 minutes
    })
}
